const FormActionPlan = () => import(/* webpackChunkName: "formActionPlan" */ './FormActionPlan.vue')
const ActionPlan = () => import(/* webpackChunkName: "actionPlan" */ './ActionPlan.vue')

const create = {
  path: 'action/plan/create',
  name: 'Create Action Plan',
  component: FormActionPlan,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

const index = {
  path: 'action/plan',
  name: 'Action Plan',
  component: ActionPlan,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

const edit = {
  path: 'action/plan/edit/:idPlanoAcao',
  name: 'Edit Action Plan',
  component: FormActionPlan,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  create,
  index,
  edit
}

export {
  create,
  index,
  edit
}
